import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import HeroSection from "../components/home/HeroSection";
import ServiceHighlights from "../components/home/ServiceHighlights";
import Services from "../components/home/Services";
import PricingTable from "../components/home/PricingTable";
import Testimonials from "../components/home/Testimonials";
import LocationsSection from "../components/home/LocationsSection";
import FaqSection from "../components/home/FaqSection";
import CTASection from "../components/home/CTASection";
import TelecomServices from "../components/home/TelecomServices";
import PrepaidPlans from "../components/PrepaidPlans";
import FlyerModal from "../components/home/FlyerModal";
const Home = () => {
    return (_jsxs(_Fragment, { children: [_jsx(FlyerModal, {}), _jsx(HeroSection, {}), _jsx(ServiceHighlights, {}), _jsx(Services, {}), _jsx(TelecomServices, {}), _jsx(PrepaidPlans, {}), _jsx(PricingTable, {}), _jsx(Testimonials, {}), _jsx(LocationsSection, {}), _jsx(FaqSection, {}), _jsx(CTASection, {})] }));
};
export default Home;
